<template>
	<div class="SelectPanel" ref="SelectPanel" :style="`${isFocus ? 'visibility: visible !important;' : ''}`">
		<slot name="prefix" @click="isFocus = true"></slot>
		<el-input ref="input" :class="{ input: true, isFocus: isFocus, hasClear: clearable && !!value && !disabled }" v-popover:popover :value="displayValue"
			:placeholder="placeholder" :readonly="readonly" :disabled="disabled" :style="`width: ${width}`"
			@focus="inputFocus" @blur="isFocus = false" @input="input" @keydown.native="keyboardOn">
			<i v-show="clearable && !!value && !disabled" slot="suffix" class="el-input__icon el-icon-circle-close input_icon" @click="clear"></i>
			<i v-show="caretShow && !!value && !disabled" slot="suffix" class="el-input__icon el-icon-caret-bottom"></i>
		</el-input>
		<slot name="suffix"></slot>
		<el-popover :disabled="disabled" ref="popover" popper-class="SelectPanel_popover" placement="bottom-start"
			:append-to-body="true" v-model="isFocus" trigger="focus">
			<div class="panel" :style="`width: calc(${columnsNum * itemWidth}px - ${columnsNum}px)`">
				<div v-for="(item, index) in options" :key="index"
					:class="{ panel_item: true, panel_item_hover: hoverIndex === index, panel_item_active: item[valueKey] === value }"
					:style='`width: ${itemWidth}px`' @click="selectOn(item[valueKey])">
					<div class="panel_item_inner">
						<span class="panel_item_label">{{ item[labelKey] }}</span>
						<span v-if="item.description" class="panel_item_description">{{ item.description }}</span>
					</div>
				</div>
			</div>
			<div class="footer">
				<slot name="footer"></slot>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { isNull } from '@/utils/validateBase';
export default {
	name: 'SelectPanel',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [Number, String, Boolean],
			default: ''
		},
		placeholder: {
			type: [String],
			default: '请输入'
		},
		columnsNum: {
			type: [Number],
			default: 2
		},
		width: {
			type: [String, Number],
			default: ''
		},
		itemWidth: {
			type: [Number],
			default: 90
		},
		options: {
			type: [Array],
			default: function () {
				return []
			},
			clearable: {
				type: [Boolean, Number, String],
				default: false 
			},
			clearable: {
				type: [Boolean, Number, String],
				default: false 
			}
		},
		labelKey: {
			type: [String],
			default: 'label'
		},
		valueKey: {
			type: [String],
			default: 'value'
		},
		readonly: {
			type: [Boolean, Number, String],
			default: false
		},
		disabled: {
			type: [Boolean, Number, String],
			default: false
		},
		clearable: {
				type: [Boolean, Number, String],
				default: false 
		},
		caretShow: {
				type: [Boolean, Number, String],
				default: false 
		},
	},
	data() {
		return {
			isFocus: false,
			hoverIndex: 0
		}
	},
  computed: {
  displayValue() {
      if (!this.value) return '';
      const item = this.options.find(v => v[this.valueKey] == this.value);
      return item ? item[this.labelKey] : this.value;
    }
  },
	mounted() {
    // 在挂载时将事件监听器添加到文档上
    document.addEventListener("click", this.handleClickOutside);
  	},
 	 beforeDestroy() {
    // 在卸载组件之前删除事件监听器
    document.removeEventListener("click", this.handleClickOutside);
  },
	methods: {
		selectOn(val) {
			this.isFocus = false;
			this.$refs['input'].blur();
			this.$emit('input', val);
			this.$emit('select', val);
		},
		inputFocus() {
			this.isFocus = true;
			this.hoverIndex = Math.max(this.options.findIndex(v => v[this.valueKey] === this.value), 0);
			this.$emit('focus');
		},
		input(val) {
			this.$emit('input', val);
		},
		focus() {
			this.$refs['input'].focus();
		},
		clear(){
				this.isFocus = false;
				this.$refs['input'].blur();
				this.$emit('input', '');
		},
		keyboardOn(e) {
			const keyList = ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft', 'Enter']
			if (keyList.includes(e.key)) {
				e.preventDefault();
			}
			const [minIndex, maxIndex] = [0, this.options.length - 1]
			switch (e.key) {
				case 'ArrowUp':
					if ((this.hoverIndex - this.columnsNum) >= minIndex) {
						this.hoverIndex = this.hoverIndex - this.columnsNum;
					}
					break;
				case 'ArrowRight':
					if (this.hoverIndex < maxIndex && this.hoverIndex % this.columnsNum !== (this.columnsNum - 1)) {
						this.hoverIndex = this.hoverIndex + 1
					}
					break;
				case 'ArrowDown':
					if ((this.hoverIndex + this.columnsNum) <= maxIndex) {
						this.hoverIndex = this.hoverIndex + this.columnsNum;
					}
					break;
				case 'ArrowLeft':
					if (this.hoverIndex % this.columnsNum !== 0) {
						this.hoverIndex = this.hoverIndex - 1
					}
					break;
				case 'Enter':
					const val = this.options[this.hoverIndex][this.valueKey];
					this.selectOn(val);
					this.$emit('enter');
					break;
			}
		},
		handleClickOutside(event) {
			// 如果点击的不是目标 DIV 或目标 DIV 的子元素，则隐藏目标 DIV
			if (!isNull(this.$refs.SelectPanel)) {
				if (!this.$refs.SelectPanel.contains(event.target)) {
					this.isFocus = false;
				} else {
					this.isFocus = true
				}
			}
		},

	}
}
</script>

<style lang="less" scoped>
.SelectPanel {
	position: relative;
	z-index: 1;
	width: 95%;
	height: 32px;
	display: flex;
}
.input_icon{
		display: none;
		line-height: 100%;
		cursor: pointer;
	}

.input:hover .input_icon{
	display: inline;	
}
.input /deep/ .el-input__inner {
	padding: 3px 6px;
	height: 32px;
	border: 1px solid transparent;
}

.input.hasClear /deep/ .el-input__inner {
	padding: 3px 18px 3px 6px;
}

.input /deep/ .el-input__inner:hover {
	border-bottom: 1px solid #0270c9;
}

.isFocus /deep/ .el-input__inner {
	border-bottom: 1px solid #0270c9;
}

.panel {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	border: 1px solid #E9E9E9;
	border-radius: 4px 4px 0 0;
}

.panel_item {
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 -1px -1px 0;
	padding: 0 6px;
	height: 32px;
	border-right: 1px solid #E9E9E9;
	border-bottom: 1px solid #E9E9E9;
	cursor: pointer;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.panel_item_hover,
.panel_item:hover {
	border-left: 1px solid #E9E9E9;
	border-top: 1px solid #E9E9E9;
	background-color: #F7F7F8;
}

.panel_item_inner {
	display: flex;
	justify-content: center;
	align-items: flex-end;
}

.panel_item_label {
	line-height: 14px;
	font-size: 14px;
	color: #000000;
}

.panel_item_description {
	margin: 0 0 0 2px;
	line-height: 10px;
	font-size: 10px;
	color: #667182;
}

.panel_item_active {
	background-color: #E8F4FF !important;
	border-top: 1px solid #E9E9E9;
	border-left: 1px solid #E9E9E9;
}

.panel_item_active .panel_item_label {
	color: #1890FF;
}
</style>

<style lang="less">
.SelectPanel_popover {
	padding: 0px;
	width: initial;
	min-width: 0;
}
</style>
